import React from 'react';
import { useIntl } from 'react-intl';
import { Button, Image } from 'semantic-ui-react';
import hideLabels from '@/assets/images/remove-label.svg';
import focusLayout from '@/assets/images/single-layout.svg';
import tabbedLayout from '@/assets/images/tabbed-layout.svg';
import devLayout from '@/assets/images/development-layout.svg';
import Selectors from '@/auth/hooks/selectors';
import Events from '@/layout/hooks/events';
import ThemesDropdown from '@/themes/components/ThemesDropdown';

const FairLayout = () => {
  const intl = useIntl();
  const { approved, isGuest } = Selectors.useApprovedIsGuest();
  const changeLayout = Events.useUpdateLayout();
  const toggleLabels = Events.useUpdateShowLabels();

  return (
    <>
      {!isGuest && (<ThemesDropdown />)}
      <Button.Group size="small" icon>
        <Button
          className="remove-label"
          data-tooltip={intl.formatMessage({ id: 'ribbon.layout.labels' })}
          data-position="left center"
          onClick={toggleLabels}
        >
          <Image src={hideLabels} alt={intl.formatMessage({ id: 'ribbon.layout.labels' })} />
        </Button>
      </Button.Group>
      {approved && (
        <Button.Group size="small" icon>
          <Button
            data-tooltip={intl.formatMessage({ id: 'ribbon.layout.focus' })}
            data-position="left center"
            onClick={() => changeLayout({ layout: 'focus' })}
          >
            <Image src={focusLayout} alt={intl.formatMessage({ id: 'ribbon.layout.focus' })} />
          </Button>
          <Button
            data-tooltip={intl.formatMessage({ id: 'ribbon.layout.tab' })}
            data-position="left center"
            onClick={() => changeLayout({ layout: 'tab' })}
          >
            <Image src={tabbedLayout} alt={intl.formatMessage({ id: 'ribbon.layout.tab' })} />
          </Button>
          {!isGuest && (
          <Button
            data-tooltip={intl.formatMessage({ id: 'ribbon.layout.ide' })}
            data-position="left center"
            onClick={() => changeLayout({ layout: 'ide' })}
          >
            <Image src={devLayout} alt={intl.formatMessage({ id: 'ribbon.layout.ide' })} />
          </Button>
          )}
        </Button.Group>
      )}
    </>
  );
};

export default FairLayout;
